var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import qs from 'query-string';
import { createContext, useCallback, useContext, useMemo, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
var baseParseOptions = { arrayFormat: 'comma', parseNumbers: true, parseBooleans: true };
var baseStringifyOptions = { arrayFormat: 'comma' };
export var UseFiltersContext = createContext([{}, function () { }]);
export function UseFiltersContextWrapper(props) {
    var ref = useRef({});
    var options = props.options;
    var paramConfigMap = options === null || options === void 0 ? void 0 : options.paramConfigMap;
    var push = useHistory().push;
    var search = useLocation().search;
    var setFilter = useCallback(function (filter) {
        var _a;
        var value = typeof filter === 'function' ? filter(ref.current.filter) : filter;
        ref.current.ignoreNextSearchChange = true;
        ref.current.filter = value;
        var filterCopy = __assign({}, value);
        if (paramConfigMap) {
            Object.keys(paramConfigMap).forEach(function (key) {
                var pk = paramConfigMap[key];
                if (pk.encode) {
                    filterCopy[key] = pk.encode(value[key]);
                }
            });
        }
        var transform = (_a = options === null || options === void 0 ? void 0 : options.stringifyOptions) === null || _a === void 0 ? void 0 : _a.transform;
        push({
            search: qs.stringify(transform ? transform(filterCopy) : filterCopy, baseStringifyOptions).replace(/%2C/g, ','),
        });
    }, [push, options === null || options === void 0 ? void 0 : options.stringifyOptions, paramConfigMap]);
    var context = useMemo(function () {
        var _a;
        if (ref.current.ignoreNextSearchChange) {
            ref.current.ignoreNextSearchChange = false;
            return [ref.current.filter, setFilter];
        }
        var transform = (_a = options === null || options === void 0 ? void 0 : options.parseOptions) === null || _a === void 0 ? void 0 : _a.transform;
        var result = qs.parse(search, baseParseOptions);
        if (paramConfigMap) {
            Object.keys(paramConfigMap).forEach(function (key) {
                var config = paramConfigMap[key];
                if (result[key] !== undefined) {
                    result[key] = config.decode(result[key]);
                }
                else if (config._defaultValue !== undefined) {
                    result[key] = config._defaultValue;
                }
            });
        }
        ref.current.filter = transform ? transform(result) : result;
        return [ref.current.filter, setFilter];
    }, [setFilter, search, options === null || options === void 0 ? void 0 : options.parseOptions, paramConfigMap]);
    return _jsx(UseFiltersContext.Provider, __assign({ value: context }, { children: props.children }), void 0);
}
export default function useFilters() {
    return useContext(UseFiltersContext);
}
export function getTypedUseFilters(paramConfigMap) {
    return useFilters;
}
export * from './paramConfigMap';
